<template>
  <svg
    v-if="!props.active"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 10.5001H12.0001L12 12.5001L18 7.63403L12 3.5L12 5.50008H6H3"
      stroke="#333333"
      stroke-width="1.5" />
    <path
      d="M21 13.5001L12 13.5001L12.0001 11.5001L6.00028 16.5L12 20.5L12.0001 18.5L15.5001 18.5001L19 18.5"
      stroke="#4D4D4D"
      stroke-width="1.5" />
  </svg>
  <svg
    v-else
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M12 10.5V12.5L18 7.5L12 3.5V5.5H5.5V10.5H12Z" fill="url(#paint0_linear_3669_9648)" />
    <path
      d="M12.24 13.2222L12.24 11L6 16.5556L12.24 21L12.24 18.7778L19 18.7778L19 13.2222L12.24 13.2222Z"
      fill="url(#paint1_linear_3669_9648)" />
    <path
      d="M5.5 10.5001H12.0001L12 12.5001L18 7.63403L12 3.5L12 5.50008H6H3"
      stroke="url(#paint2_linear_3669_9648)"
      stroke-width="1.5" />
    <path
      d="M21 13.5001L12 13.5001L12.0001 11.5001L6.00028 16.5L12 20.5L12.0001 18.5L15.5001 18.5001L19 18.5"
      stroke="url(#paint3_linear_3669_9648)"
      stroke-width="1.5" />
    <defs>
      <linearGradient
        id="paint0_linear_3669_9648"
        x1="9.25"
        y1="5.5"
        x2="17.9514"
        y2="9.83985"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" stop-opacity="0" />
        <stop offset="1" stop-color="#8F42FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3669_9648"
        x1="14.06"
        y1="14.3333"
        x2="10.6044"
        y2="20.8184"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3669_9648"
        x1="6.28125"
        y1="3.5"
        x2="2.53125"
        y2="3.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" />
        <stop offset="1" stop-color="#562899" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3669_9648"
        x1="18"
        y1="11.5001"
        x2="21.5"
        y2="11.5001"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="white" />
        <stop offset="1" stop-color="#999999" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});
</script>
